import React from 'react';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react-text';
import { localsMessages } from '../utility/getTemplateData';
import OfferDetail from './offerDetail';
import OfferSaveButton from './offerSaveButton';

const messages = localsMessages('confirmation/confirmation');

class OfferConfirmation extends React.Component {
  createMarkup(content) {
    return {
      __html: content,
    };
  }
  render() {
    const { offerProgram } = this.props;
    return (
      <div>
        <div className="ppvx_row">
          <div className="ppvx_col-12 text-center">
            <BodyText
              style={{
                textAlign: 'center',
                margin: '0 auto 24px',
                maxWidth: '415px',
              }}
              dangerouslySetInnerHTML={{ __html: messages.label.offer }}
            ></BodyText>
          </div>
        </div>
        <OfferDetail offerProgram={offerProgram} success={true} />
        <OfferSaveButton
          offerProgram={offerProgram}
          txnStatement={this.props.txnId}
        />
      </div>
    );
  }
}

OfferConfirmation.propTypes = {
  offerProgram: PropTypes.object.isRequired,
  txnId: PropTypes.string,
};

export default OfferConfirmation;
